import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {getQuotes, getQuotesError, getQuotesStatus, selectGetQuotesArray} from "../../redux/ProjectsSlice";
import {useNavigate} from "react-router";
import LoadingError from "../Error/LoadingError";
import {DataGridPro, GridToolbar} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {NoRowsDialog} from "../Inputs/NoRowsDialog";
import {IconButton} from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

function ProjectSummaryTable() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const quotes = useSelector(selectGetQuotesArray);
    const status = useSelector(getQuotesStatus);
    const error = useSelector(getQuotesError);
    
    useEffect(() => {
        if (status === 'idle') {
            dispatch(getQuotes());
        }
    }, [dispatch, status]);
    
    const handleRowClick = (event) => {
        navigate(`/projects/${event.id}`);
    };

    const columns = [
        { field: 'friendlyId', headerName: 'Id', headerClassName: 'quotes-theme--header', cellClassName: 'hyperlink', width: 150 },
        {
            field: 'jobVaultLink',
            headerName: 'Files',
            headerClassName: 'quotes-theme--header',
            width: 20,
            renderCell: (params) => (
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent row click event
                        if (params.value) {
                            window.open(params.value, '_blank');
                        }
                    }}
                    disabled={!params.value}
                >
                    <OpenInNewIcon fontSize="small" />
                </IconButton>
            )
        },
        { field: 'purchaseOrderNumber', headerName: 'PO No.', headerClassName: 'quotes-theme--header', width: 120, valueFormatter: (value) => value || '-' },
        { field: 'jobNumber', headerName: 'Job No.', headerClassName: 'quotes-theme--header', width: 120, valueFormatter: (value) => value || '-' },
        { field: 'externalQuoteNumber', headerName: 'Quote No.', headerClassName: 'quotes-theme--header', width: 120, valueFormatter: (value) => value || '-' },
        { field: 'description', headerName: 'Description', headerClassName: 'quotes-theme--header', width: 150 },
        { field: 'quoteStatus', headerName: 'Status', headerClassName: 'quotes-theme--header', width: 120 },
        { field: 'clientName', headerName: 'Client', headerClassName: 'quotes-theme--header', width: 150 },
        { field: 'createdAt', headerName: 'Created At', headerClassName: 'quotes-theme--header', width: 170 }
    ];
    
    return (
        <Box sx={{
                display: 'flex', 
                flexDirection: 'column', 
                minHeight: '350px', 
                maxHeight: '600px',
                "& .MuiDataGrid-row:hover": {
                    cursor: "pointer",
                },
                '& .quotes-theme--header': {
                        color: 'white',
                    }
                }}
        >
            <DataGridPro
                checkboxSelection
                disableRowSelectionOnClick
                columns={columns}
                initialState={{
                    density: 'compact',
                }}
                onRowClick={handleRowClick}
                rows={quotes}
                loading={status === 'loading'}
                slots={{
                    toolbar: !error && GridToolbar,
                    noRowsOverlay: () => error ? <LoadingError component={"projects"} /> : <NoRowsDialog path={"projects"} domain={"Project"} />
                }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                    loadingOverlay: {
                        variant: 'skeleton',
                        noRowsVariant: 'skeleton',
                    },
                }}
            />
        </Box>
    )
}

export default ProjectSummaryTable;